<mat-chip disabled [ngClass]="getCssClass()" selected>{{ getLabel() }}</mat-chip>